export const CHECKOUT_URL =
  'https://running-para-cambiar-vidas.impultienda.ar/checkout'

export const images = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/71dd5a0d-6391-44a3-aac9-d9318a8163b5.jpg',
  pack: 'https://cdn.magicpatterns.com/patterns/generated-images/285c2fa0-2925-425f-bd43-71bb60858108.jpg',
  author: 'https://cdn.magicpatterns.com/patterns/generated-images/76d83684-37f3-470b-adc1-ab1138258e17.jpg',
  group1: 'https://cdn.magicpatterns.com/patterns/generated-images/2eb53e1c-c8c8-4635-b0f9-5781ba4885a9.jpg',
  group2: 'https://cdn.magicpatterns.com/patterns/generated-images/4eb6e608-3e0a-4d36-91db-4caa1fde4fd4.jpg',
}

export const painPoints: string[] = [
  'Pasás tus domingos estresado armando las clases de la semana.',
  'Ves que tus alumnos se estancan físicamente y no sabés cómo explicarles por qué.',
  'Te da inseguridad cuando un alumno te pregunta sobre una lesión o técnica avanzada.',
  'Sentís que cobrás poco, pero no sabés cómo justificar un aumento en tu cuota.',
  'Tus alumnos rotan mucho: vienen un mes, se aburren y se van.',
]

export type Transformation = {
  title: string
  description: string
}

export const transformations: Transformation[] = [
  {
    title: 'Planificación Natural',
    description: 'Dejá de improvisar y empezá a liderar con fluidez.',
  },
  {
    title: 'Autoridad Real',
    description: 'Respondé cada duda técnica con respaldo científico.',
  },
  {
    title: 'Comunidad Sólida',
    description: 'Creá grupos que no solo corren, sino que se acompañan.',
  },
  {
    title: 'Libertad de Tiempo',
    description: 'Recuperá tus fines de semana con sesiones ya estructuradas.',
  },
  {
    title: 'Resultados Visibles',
    description:
      'Observá cómo tus alumnos mejoran su físico y su salud de forma segura.',
  },
]

export type Tomo = {
  number: number
  title: string
  description: string
}

export const tomos: Tomo[] = [
  {
    number: 1,
    title: 'Fisiología del Cambio',
    description: 'Entendé cómo se transforma el cuerpo al correr.',
  },
  {
    number: 2,
    title: 'Biomecánica y Técnica',
    description: 'La ciencia detrás de cada zancada.',
  },
  {
    number: 3,
    title: 'La Ciencia del Entrenamiento',
    description: 'Cargas, ritmos y periodización inteligente.',
  },
  {
    number: 4,
    title: 'Prevención y Readaptación',
    description: 'Cuidá la salud de tus corredores.',
  },
  {
    number: 5,
    title: 'Poblaciones Especiales',
    description: 'Adaptá el running a cada etapa de la vida.',
  },
  {
    number: 6,
    title: 'Psicología y Motivación',
    description: 'El arte de mantener a tu grupo encendido.',
  },
]

export const audienceFor: string[] = [
  'Amás el running y querés vivir de esto.',
  'Sos profe de educación física o coach.',
  'Sos un corredor avanzado que quiere enseñar.',
  'Valorás la estructura y el profesionalismo.',
]

export const audienceNotFor: string[] = [
  'Buscás una fórmula mágica sin estudiar.',
  'No te interesa el bienestar de tus alumnos.',
  'Querés seguir improvisando sobre la marcha.',
  "Creés que 'correr por correr' es suficiente.",
]

export type Testimonial = {
  quote: string
  author: string
  role: string
  time: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'Desde que uso las plantillas, mis alumnos están más motivados y yo más tranquilo.',
    author: 'Profe Julián',
    role: 'Grupo de running · Córdoba',
    time: '7:42',
  },
  {
    quote:
      'Pude subir mi cuota un 30% porque ahora mi servicio se ve realmente premium.',
    author: 'Entrenadora Sofía',
    role: 'Running team · Montevideo',
    time: '20:15',
  },
]

export type OfferItem = {
  label: string
  detail: string
  price: string
  highlight?: boolean
}

export const offerItems: OfferItem[] = [
  {
    label: 'Los 6 Tomos Digitales',
    detail: 'Ebooks en PDF de alta calidad',
    price: '$34.900',
    highlight: true,
  },
  {
    label: 'Bono 1: Rutina de calentamiento y vuelta a la calma',
    detail: 'Lista para aplicar en cada clase',
    price: '$8.900',
  },
  {
    label: 'Bono 2: Plan de progresión de 4 semanas',
    detail: 'Estructura semana por semana',
    price: '$12.900',
  },
  {
    label: 'Bono 3: Guía para mantener la motivación',
    detail: 'Recursos para sostener el hábito',
    price: '$8.900',
  },
  {
    label: 'Bono 4: Cómo mantener a tus alumnos motivados por años',
    detail: 'Retención y comunidad a largo plazo',
    price: '$9.900',
  },
  {
    label: 'Bono 5: Apps y software para optimizar tus entrenamientos',
    detail: 'Herramientas que usan los profesionales',
    price: '$16.900',
  },
]

export type PurchaseNotice = {
  name: string
  province: string
  minutes: number
}

export const purchaseNotices: PurchaseNotice[] = [
  { name: 'Pablo', province: 'San Luis', minutes: 5 },
  { name: 'Carolina', province: 'Córdoba', minutes: 8 },
  { name: 'Martín', province: 'Mendoza', minutes: 3 },
  { name: 'Lucía', province: 'Santa Fe', minutes: 11 },
  { name: 'Diego', province: 'Salta', minutes: 6 },
  { name: 'Valeria', province: 'Buenos Aires', minutes: 2 },
  { name: 'Nicolás', province: 'Tucumán', minutes: 14 },
  { name: 'Sofía', province: 'Neuquén', minutes: 9 },
  { name: 'Federico', province: 'Entre Ríos', minutes: 4 },
  { name: 'Camila', province: 'Chubut', minutes: 12 },
]

export const pricing = {
  totalValue: '$92.400',
  today: '$23.999',
}

export type Faq = {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: '¿El material es físico?',
    answer:
      'No, es 100% digital en PDF de alta calidad para que lo lleves en tu celular a la pista.',
  },
  {
    question: '¿Tengo acceso para siempre?',
    answer:
      'Sí, lo descargás y es tuyo de por vida, incluyendo actualizaciones.',
  },
  {
    question: '¿Sirve para cualquier país?',
    answer:
      'Sí, los fundamentos del running son universales y podés pagar en tu moneda local.',
  },
  {
    question: '¿Hay garantía?',
    answer: 'Absolutamente. 7 días de garantía de satisfacción.',
  },
]
